import axios from "axios";

export default () => {
  return axios.create({
	baseURL: `//boyte.info/api`
	//baseURL: `http://10.240.192.183:3005`
	
  });
};